import React from 'react'
import { theme } from 'antd';
import { Image } from 'antd';

interface Cw8ListFieldAttachmentProps{
    record: any
}

const Cw8ListFieldAttachment = ({record} : Cw8ListFieldAttachmentProps) => {
// console.log(record)
    if (Array.isArray(record)) {
        return(
            <> 
            {record.map( item =>(
                <Image src={item.thumbnails.large.url} style={{maxWidth:"150px"}}/>
            ) )}
            </>
        )
      } else {
        return (
            <div>
                {/* La variable no es un array */}
                {/* <Image src={record.thumbnails.large.url} style={{maxWidth:"150px"}}/> */}
            </div>
        )          
    }

}


export default Cw8ListFieldAttachment
